import fetchAPI from '../utils/fetchApi';

type TArgs = {
  feedOptions: {
    feedType: string;
    postcode?: string;
    offset?: number;
    limit?: number;
    asListings?: boolean;
  };
  xsrfToken: string;
};

export default ({ feedOptions: { feedType, postcode, offset, limit, asListings }, xsrfToken }: TArgs) =>
  fetchAPI({
    method: 'POST',
    url: '/lp/api/feed-items',
    payload: {
      feedType,
      postcode,
      offset,
      limit,
      asListings,
    },
    xsrfToken,
  });
